import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh', background:'var(--troly-bg)', color:'var(--troly-action)', fontSize:14 }}>Cargando...</div>;
  return user ? children : <Navigate to="/trigger" replace />;
}
